﻿import {translation} from "@2d-front-monorepo/core";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";

export interface MetersProps {
	meters: string[];
}

export default function Meters({meters}: MetersProps): JSX.Element {
	if (meters == null || meters.length === 0) {
		return <></>;
	}

	return (
		<div className="card card--padded">
			<dl className="title-desc">
				<dt>{translation(PermitTranslations.reservation_meters)}</dt>
				<dd className="grid">{meters.map(m => <div key={m} className="col-1of4">{m}</div>)}</dd>
			</dl>
		</div>
	);
}
